export const passwordRequirements: string[] = [
    'Be a minimum of 16 characters in length',
    'Contain at least 1 number',
    'Contain at least 1 special character',
    'Contain at least 1 uppercase letter',
    'Contain at least 1 lowercase letter'
];